import { __export, boot } from './chunk-YAU6GWLC.js';
import { useRef, useState, useEffect } from 'react';

// lib/hooks/index.ts
var hooks_exports = {};
__export(hooks_exports, {
  useFrontChat: () => useFrontChat,
  useFrontChatBoot: () => useFrontChatBoot
});
function useFrontChatBoot(element, options) {
  const scriptTagAppended = useRef(false);
  const [status, setStatus] = useState("idle" /* IDLE */);
  useEffect(() => {
    (async () => {
      if (scriptTagAppended.current) {
        return;
      }
      scriptTagAppended.current = true;
      await boot(element, options);
      setStatus("ready" /* READY */);
    })().catch(console.error);
  }, [element, options]);
  if (status === "idle" /* IDLE */) {
    return { frontChat: void 0, isInitialized: false, initialize: void 0 };
  }
  const frontChat = (cmdType, params) => {
    if (!window.FrontChat) {
      console.error("[front-chat-sdk] Have not finished setting up window.FrontChat");
      return;
    }
    if (cmdType === "init" /* INIT */) {
      const onInitCompleted = () => {
        setStatus("initialized" /* INITIALIZED */);
      };
      return window.FrontChat(cmdType, { ...params, onInitCompleted });
    }
    if (cmdType === "shutdown" /* SHUTDOWN */) {
      setStatus("ready" /* READY */);
    }
    return window.FrontChat(cmdType, params);
  };
  const initialize = (params) => {
    if (status === "initialized" /* INITIALIZED */) {
      return;
    }
    frontChat("init" /* INIT */, params);
  };
  return {
    frontChat,
    isInitialized: status === "initialized" /* INITIALIZED */,
    initialize
  };
}

// lib/hooks/use-front-chat/index.ts
function useFrontChat(chatId, element) {
  const { frontChat, isInitialized, initialize } = useFrontChatBoot(element);
  useEffect(() => {
    if (isInitialized || !initialize || !chatId) {
      return;
    }
    initialize({ chatId });
  }, [chatId, isInitialized, initialize]);
  return { frontChat, isInitialized, initialize };
}

export { hooks_exports, useFrontChat, useFrontChatBoot };
//# sourceMappingURL=chunk-36IFZXOB.js.map
//# sourceMappingURL=chunk-36IFZXOB.js.map